/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerToolCallDetailQueryResponse, IncidentInvestigationControllerToolCallDetailPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerToolCallDetail";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerToolCallDetail } from "../../clients/incident-agentService/incidentInvestigationControllerToolCallDetail";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerToolCallDetailQueryKey = (id: IncidentInvestigationControllerToolCallDetailPathParams["id"], toolCallId: IncidentInvestigationControllerToolCallDetailPathParams["toolCallId"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/tool-calls/:toolCallId/detail',
  params: {
    id: id,
    toolCallId: toolCallId
  }
}] as const;
export type IncidentInvestigationControllerToolCallDetailQueryKey = ReturnType<typeof incidentInvestigationControllerToolCallDetailQueryKey>;
export function incidentInvestigationControllerToolCallDetailQueryOptions(id: IncidentInvestigationControllerToolCallDetailPathParams["id"], toolCallId: IncidentInvestigationControllerToolCallDetailPathParams["toolCallId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerToolCallDetailQueryKey(id, toolCallId);
  return queryOptions<IncidentInvestigationControllerToolCallDetailQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerToolCallDetailQueryResponse, typeof queryKey>({
    enabled: !!(id && toolCallId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerToolCallDetail(id, toolCallId, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/tool-calls/:toolCallId/detail}
 */
export function useIncidentInvestigationControllerToolCallDetail<TData = IncidentInvestigationControllerToolCallDetailQueryResponse, TQueryData = IncidentInvestigationControllerToolCallDetailQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerToolCallDetailQueryKey>(id: IncidentInvestigationControllerToolCallDetailPathParams["id"], toolCallId: IncidentInvestigationControllerToolCallDetailPathParams["toolCallId"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerToolCallDetailQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerToolCallDetailQueryKey(id, toolCallId);
  const query = useQuery({
    ...incidentInvestigationControllerToolCallDetailQueryOptions(id, toolCallId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}